<div class="app-modal">
  <section class="app-modal-header">
    <h1>{{ 'general.termsAndConditions' | translate }}</h1>
    <a href="javascript:void(0)" class="app-modal-close-icon" (click)="onCloseClick()"></a>
  </section>
  <section class="app-modal-content">
    <ng-container>
      @if (base64) {
        <app-ng2-pdf-viewer [pdfSrc]="base64"> </app-ng2-pdf-viewer>
      }
    </ng-container>
  </section>
  <div class="app-modal-footer">
    <a
      href="javascript:void(0)"
      class="simple-btn simple-btn-rounded simple-btn-text-grey simple-btn-md bigger-side-pads"
      (click)="onCloseClick()">
      <span>{{ 'general.close' | translate }}</span>
    </a>
  </div>
</div>
